export default (emailPart: string, message: string) => (value: string): string | boolean => {
  if (!value) {
    return true;
  }
  return !value.includes(emailPart) || message;
};
